var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('date-range-picker', {
    attrs: {
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "max-date": _vm.maxDate,
      "controlContainerClass": {
        disabled: _vm.disabled
      },
      "single-date-picker": _vm.isRange ? false : true,
      "opens": _vm.direction || 'right',
      "ranges": _vm.ranges || false,
      "placeholder": _vm.$t(_vm.placeholder),
      "time-picker": _vm.timePicker || false,
      "time-picker-increment": _vm.timePickerIncrement || 1,
      "show-dropdowns": _vm.showDropDowns || true,
      "auto-apply": _vm.isRange,
      "locale-data": _vm.isViLanguage ? {
        format: 'mm/dd/YYYY HH:mm',
        daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
        monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        firstDay: 0
      } : undefined
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }